import { render, staticRenderFns } from "./additional-material.vue?vue&type=template&id=0f91bacf&scoped=true&"
import script from "./additional-material.vue?vue&type=script&lang=js&"
export * from "./additional-material.vue?vue&type=script&lang=js&"
import style0 from "./additional-material.vue?vue&type=style&index=0&id=0f91bacf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f91bacf",
  null
  
)

export default component.exports